/*
* @Author: zhangzhitao
* @Date: 2019-07-05 10:18:23
* @Des:
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-05-25 11:14:42
*/

<template>
  <div>
    <div class="m-about-ctn">
      <div class="u-logo-wrap">
        <div
          class="u-logo-box"
          :style="
            `background-image:url('${aboutInfo.aboutIconInfo.path || 'none'}')`
          "
        ></div>
      </div>
      <div class="m-ablout-wrap">
        <div class="n-sys-info">
          <div class="sys-name">{{ aboutInfo.systemName }}</div>
          <div class="sys-sub-name">{{ aboutInfo.systemSubtitle }}</div>
        </div>
        <span class="u-ctn"><span class="u-label">{{ $t("indexPage.copyright") }}</span>{{ aboutInfo.systemVersion }}</span>
        <span class="u-ctn"><span class="u-label">{{
            $t("indexPage.authorization_message")
            }}</span>{{ $t("indexPage.go_to")
          }}<a
            target="_blank"
            :href="aboutInfo.bicUrl"
            style="font-weight:100;"
          >{{ $t("indexPage.yxglzx") }}</a>{{ $t("indexPage.check") }}</span>
      </div>
    </div>
    <div class="m-about-bottom">
      <div class="m-statement">
        <a
          v-if="aboutBottomInfo.license"
          :href="aboutBottomInfo.license"
          target="_blank"
          :title="$t('indexPage.about_protocol3')"
        ><i class="icon h-icon-details"></i><span>{{ $t("indexPage.about_protocol3") }}</span></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'neutral',

  props: {
    aboutInfo: {
      type: Object,
      default: () => {
        return {
          aboutIconInfo: {
            path: '',
            fileId: '-1'
          }
        }
      }
    },
    aboutBottomInfo: {
      type: Object,
      default: () => {
        return {

        }
      }
    },
    baseUrl: {
      type: String,
      default: process.env.VUE_APP_BASEURL
    },
    language: {
      type: String,
      default: 'zh_CN'
    }
  },

  data () {
    return {
    }
  },

  components: {},

  computed: {},

  mounted () { },

  methods: {}
}

</script>

<style lang="less" scoped>
.m-about-ctn {
  width: 100%;
  padding: 40px 0 40px;
  font-size: 12px;
  overflow: hidden;
  .u-logo-wrap {
    float: left;
    width: 180px;
    height: 100%;
    .u-logo-box {
      float: right;
      width: 120px;
      height: 120px;
      margin-top: 14px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
  .m-ablout-wrap {
    float: right;
    width: calc(~"100% - 200px");
    height: 100%;
    color: rgba(0, 0, 0, 0.9);
    .n-sys-info {
      .sys-name {
        font-size: 22px;
      }
      .sys-sub-name {
        font-size: 14px;
      }
      padding-bottom: 8px;
    }
    span {
      display: block;
      line-height: 24px;
    }
    .u-ctn {
      font-weight: bold;
    }
    .u-label {
      float: left;
      color: rgba(0, 0, 0, 0.7);
      margin-right: 8px;
      font-weight: 100;
    }
    a {
      color: #2196f3;
      text-decoration: none;
    }
  }
}
.m-about-bottom {
  width: 100%;
  background: rgba(0, 0, 0, 0.02);
  .m-statement {
    position: relative;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    a {
      display: block;
      max-width: 180px;
      margin: 0 auto;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.7);
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      .icon {
        float: left;
        margin-right: 8px;
        font-size: 24px !important;
      }
    }
  }
  .m-about-ul {
    width: 100%;
    box-sizing: border-box;
    list-style: none;
    padding: 0 60px;
    margin: 0;
    overflow: hidden;
    font-size: 12px;
    .u-copy-right {
      display: block;
      width: 100%;
      text-align: center;
      padding: 16px 0;
      color: rgba(0, 0, 0, 0.4);
    }
    i {
      font-size: 16px;
      margin-right: 8px;
      padding-top: 3px;
    }
  }
}
</style>
